import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { queryParams, withQueryParams } from '@shared/commonFunctions';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IFedexData, IGenerateFedexLabelResponse } from './interfaces';

const path = `/${SERVICES.DOCUMENT}/shipping`;

export const submitFedexLabelForm = (data: IFedexData, dealId: string) => {
  return mutate<IGenerateFedexLabelResponse>(`${path}/deals/${dealId}`, async () => {
    try {
      const response = await axios.post<IGenerateFedexLabelResponse>(`${path}/deals/${dealId}`, data);

      if (response.data.errorMessages.length) {
        Notistack.generalError(response.data.errorMessages[0]);
        return;
      }

      Notistack.successMessage('Fedex Label - generated Successfully');
      return response.data;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const getLabel = async (labelId: string, isInBatch = false, trackingNumber?: string) => {
  try {
    const resp = await axios.get(withQueryParams(`${path}/deals/${queryParams()?.dealId}/labels/${labelId}`, { isInBatch, trackingNumber: (isInBatch ? trackingNumber : null) }, false));
    return resp;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestIncludeReadyToShip = async (dealId: string, checked = false) => {
  const url = `${SERVICES.DEAL}/deals/${dealId}/shipments/${checked ? 'include' : 'exclude'}`;
  try {
    await axios.put(url);
    const successMessage = `${checked ? 'Included' : 'Excluded'} deal ${checked ? 'in' : 'from'} ready to ship queue`;
    Notistack.successMessage(successMessage);
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};